import React from "react";

const SvgArrowDown = props => (
  <svg width={16} height={10} viewBox="0 0 16 10" className={`svg ${props.className}`}>
    <path fill="currentColor" d="M7.854 6.732L1.56.44.146 1.854 7.854 9.56l7.707-7.707L14.146.439z" />
  </svg>
);

export default SvgArrowDown;
